import React from 'react';
import '../styles/reservations.css';
import logo from "../assets/imgs/vr.webp";
import { useTranslation } from 'react-i18next';

function ReservaEquipos() {

    const { t } = useTranslation('home');
    const redirectToReservations = () => {
        window.open('https://reservasdisc.virtual.uniandes.edu.co/', '_blank');
    };

    return (
        <div className="reserva-equipos">
            <div className="reserva-equipos-text">
                <h2>{t('reserves-title')}</h2>
                <p>{t('reserves-description-1')}</p>
                <p>{t('reserves-description-2')}</p>
            </div>
            <div className="reserva-equipos-action container">
                <div className="row">
                    <div className="col-6">
                        <button className="reserva-button" onClick={redirectToReservations}>{t('reserves-button')}</button>
                    </div>
                    <div className="col-6">
                        <div className="reserva-equipos-image">
                            <img src={logo} alt="VR Headset"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReservaEquipos;
